import React, { useContext } from 'react'
import { FormContext } from '../../FormContext'
  
const StepFailed: React.FC = () => {
    const context = useContext(FormContext);
  
    if (!context) {
      throw new Error("StepSuccess must be used within a FormContextProvider");
    }
  
    const { 
        handleValidationIntroduction,
    } = context;

    return (
        <div className='px-4 mt-2 my-auto'>
            <form action="" onSubmit={handleValidationIntroduction} className=''>
                <div className='mb-4 space-y-6'>
                    <h3 className='text-black text-3xl font-bold text-center'>Oops! We sincerely apologize for the inconvenience.</h3>
                    <h3 className='text-black text-md font-base text-center'>It looks like your submission was unsuccessful.</h3>
                    <h3 className='text-black text-md font-base text-center'>But don’t worry! You can always go back, refresh the page, and try again anytime.</h3>
                </div>
            </form>
        </div>
    );
}

export default StepFailed